/**
 * Created By Jeremy.caoyu at 2020-06-02
 * baseUrl配置函数
 * 测试域名： exp4pad-test.classba.cn
 * 正式域名： exp4pad.classba.cn
 */
import { judgeTempSeason } from "./util";
export const getBaseUrl = () => {
  const host = window.location.host, protocol = window.location.protocol;
  // if (host.indexOf('exp4pad-test.classba.cn') > -1) {// 测试环境
  //     return '//exp2.test.classba.cn/api/'
  // } else if (host.indexOf('account-test.classba.cn') > -1) {
  //     return '//account-test.classba.cn/api/'
  // } else if (host.indexOf('account.classba.cn') > -1) {
  //     return '//account.classba.cn/api/'
  // } else if (host.indexOf('paddl.classba.cn') > -1 || host.indexOf('exp4pad.classba.cn') > -1) {// 正式环境
  //     return `//exp4api.classba.cn/api/`;
  // } else {// 开发
  //     // return `//exp2.test.classba.cn/api/`;
  //     return `//account-test.classba.cn/api/`;
  // }
  // if (
  //   process.env.VUE_APP_ENV == "test" ||
  //   process.env.VUE_APP_ENV == "development"
  // ) {
  //   // 测试或开发环境
  //   return "//exp2.test.classba.cn/api/";
  // } else if (process.env.VUE_APP_ENV == "pre") {
  //   // 测试或开发环境
  //   return "//exp4api-pre.classba.cn/api/";
  // } else {
  //   return `//exp4api.classba.cn/api/`;
  // }
  if (host.indexOf('exp4pad-test.classba.cn') > -1) { // 测试环境
    return "//exp2.test.classba.cn/api/";
  } else if (host.indexOf('exp4pad-pre.classba.cn') > -1) { // 开发环境
    return "//exp4api-pre.classba.cn/api/";
  } else if (host.indexOf('exp4pad.classba.cn') > -1) { // 正式环境
    return `//exp4api.classba.cn/api/`;
  } else {
    return "//exp2.test.classba.cn/api/";
  }
};

// 松鼠杯荣誉配置
const springHonorDescMapConfig = new Map([
  [
    2,
    {
      title: "三连胜战队",
      acquireTime: "",
      acquireDescribe: "连续三天战队赢得胜利",
    },
  ],
  [
    4,
    {
      title: "满勤战队",
      acquireTime: "",
      acquireDescribe: "战队所有成员完成单日PK局数上限",
    },
  ],
  [
    3,
    {
      title: "最精彩的比赛",
      acquireTime: "",
      acquireDescribe: "与对手一起贡献了单日奖杯数差额最小的比赛",
    },
  ],
  [
    1,
    {
      title: "最强战队（单日）",
      acquireTime: "",
      acquireDescribe: "单日战队奖杯数排名第一",
    },
  ],
  [
    5,
    {
      title: "最强战队（赛季）",
      acquireTime: "",
      acquireDescribe: "",
    },
  ],
  [
    10,
    {
      title: "最强战队（战区）",
      acquireTime: "",
      acquireDescribe: "单日战队奖杯数战区排名第一",
    },
  ],
  [
    9,
    {
      title: "战队MVP队员",
      isMVP: true,
      userName: "",
      cupNumber: 0,
      acquireTime: "",
      acquireDescribe: "战队单日获得奖杯数排名第一",
    },
  ],
  [
    6,
    {
      title: "冠军战队", // 战区冠军
      acquireTime: "",
      acquireDescribe: "",
    },
  ],
  [
    7,
    {
      title: "亚军战队", // 战区亚军
      acquireTime: "",
      acquireDescribe: "",
    },
  ],
  [
    8,
    {
      title: "季军战队", // 战区季军
      acquireTime: "",
      acquireDescribe: "",
    },
  ],
  [
    11,
    {
      title: "全国冠军战队", // 全国冠军
      acquireTime: "",
      acquireDescribe: "",
    },
  ],
  [
    12,
    {
      title: "全国亚军战队", // 全国亚军
      acquireTime: "",
      acquireDescribe: "",
    },
  ],
  [
    13,
    {
      title: "全国季军战队", // 全国季军
      acquireTime: "",
      acquireDescribe: "",
    },
  ],
  [
    14,
    {
      title: "全国8强战队",
      acquireTime: "",
      acquireDescribe: "",
    },
  ],
  [
    15,
    {
      title: "全国16强战队",
      acquireTime: "",
      acquireDescribe: "",
    },
  ],
  [
    16,
    {
      title: "全国32强战队",
      acquireTime: "",
      acquireDescribe: "",
    },
  ],
  [
    17,
    {
      title: "晋级全国大赛",
      acquireTime: "",
      acquireDescribe: "在精英争霸赛中努力拼搏晋级全国大赛",
    },
  ],
  [
    18,
    {
      title: "晋级精英争霸赛",
      acquireTime: "",
      acquireDescribe: "从全网大乱斗中脱颖而出晋级精英争霸赛",
    },
  ],
]);
const summerHonorDescMapConfig = new Map([
  [
    2,
    {
      title: "三连胜战队",
      acquireTime: "",
      acquireDescribe: "连续三天战队赢得胜利",
    },
  ],
  [
    4,
    {
      title: "满勤战队",
      acquireTime: "",
      acquireDescribe: "战队所有成员完成单日PK局数上限",
    },
  ],
  [
    3,
    {
      title: "最精彩的比赛",
      acquireTime: "",
      acquireDescribe: "与对手一起贡献了单日最小差距的激烈比赛",
    },
  ],
  [
    1,
    {
      title: "今日最强战队",
      acquireTime: "",
      acquireDescribe: "单日战队奖杯数全网排名第一",
    },
  ],
  [
    5,
    {
      title: "最强战队（赛季）",
      acquireTime: "",
      acquireDescribe: "",
    },
  ],
  [
    10,
    {
      title: "",
      acquireTime: "",
      acquireDescribe: "单日战队奖杯数战区排名第一",
    },
  ],
  [
    19,
    {
      title: "",
      acquireTime: "",
      acquireDescribe: "单日战队奖杯数赛区排名第一",
    },
  ],
  [
    9,
    {
      title: "战队明星学员",
      isMVP: true,
      userName: "",
      cupNumber: 0,
      acquireTime: "",
      acquireDescribe: "战队单日奖杯数最多",
    },
  ],
  [
    6,
    {
      title: "冠军", // 战区冠军
      acquireTime: "",
      acquireDescribe: "",
    },
  ],
  [
    7,
    {
      title: "亚军", // 战区亚军
      acquireTime: "",
      acquireDescribe: "",
    },
  ],
  [
    8,
    {
      title: "季军", // 战区季军
      acquireTime: "",
      acquireDescribe: "",
    },
  ],
  //TODO 需要根据实际的 type 来
  [
    11,
    {
      title: "全国冠军", // 全国冠军
      acquireTime: "",
      acquireDescribe: "",
    },
  ],
  [
    12,
    {
      title: "全国亚军", // 全国亚军
      acquireTime: "",
      acquireDescribe: "",
    },
  ],
  [
    13,
    {
      title: "全国季军", // 全国季军
      acquireTime: "",
      acquireDescribe: "",
    },
  ],
  [
    14,
    {
      title: "全国8强战队",
      acquireTime: "",
      acquireDescribe: "",
    },
  ],
  [
    15,
    {
      title: "全国16强战队",
      acquireTime: "",
      acquireDescribe: "",
    },
  ],
  [
    16,
    {
      title: "全国32强战队",
      acquireTime: "",
      acquireDescribe: "",
    },
  ],
  [
    17,
    {
      title: "晋级全国大赛",
      acquireTime: "",
      acquireDescribe: "通过在精英争霸赛中努力拼搏晋级全国大赛",
    },
  ],
  [
    18,
    {
      title: "晋级精英争霸赛",
      acquireTime: "",
      acquireDescribe: "从全网大乱斗中脱颖而出晋级精英争霸赛",
    },
  ],
  [
    105,
    {
      title: "竞技场今日最强战队",
      acquireTime: "",
      acquireDescribe: "单日奖杯数竞技场排名第一",
    },
  ],
  [
    101,
    {
      title: "竞技场无冕之王",
      acquireTime: "",
      acquireDescribe: "竞技场累计奖杯数排名第一",
    },
  ],
  [
    102,
    {
      title: "竞技场亚军战队",
      acquireTime: "",
      acquireDescribe: "竞技场累计奖杯数排名第二",
    },
  ],
  [
    103,
    {
      title: "竞技场季军战队",
      acquireTime: "",
      acquireDescribe: "竞技场累计奖杯数排名第三",
    },
  ],
  [
    104,
    {
      title: "竞技场第四名战队",
      acquireTime: "",
      acquireDescribe: "竞技场累计奖杯数排名第四",
    },
  ],
  [
    100,
    {
      title: "巅峰之王",
      acquireTime: "",
      acquireDescribe: "巅峰赛获得胜利的战队",
    },
  ],
]);

export const gethonorDescMapConfig = () => {
  let [isSpring] = judgeTempSeason();
  if (isSpring) {
    return springHonorDescMapConfig;
  } else {
    return summerHonorDescMapConfig;
  }
};
